  (function() {
    // Hàm chuyển đổi X,XXEUR hoặc X.XXEUR thành € X,XX
    function formatEUR(text) {
      var regex = /(\d+(?:[\.,]\d+)?)\s*EUR/g;
      return text.replace(regex, function(match, number) {
        // Đảm bảo dùng dấu phẩy cho định dạng Châu Âu
        var formattedNumber = number.replace('.', ',');
        return '€ ' + formattedNumber;
      });
    }

    // Quét qua các node văn bản để thay thế
    function replaceCurrency(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.nodeValue && node.nodeValue.includes('EUR')) {
          node.nodeValue = formatEUR(node.nodeValue);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Bỏ qua thẻ script và style
        if (node.nodeName !== 'SCRIPT' && node.nodeName !== 'STYLE') {
          node.childNodes.forEach(replaceCurrency);
        }
      }
    }

    // Chạy lần đầu khi trang load xong
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        replaceCurrency(document.body);
      });
    } else {
      replaceCurrency(document.body);
    }

    // Lắng nghe sự thay đổi của DOM (Cực kỳ quan trọng vì Progress bar thường render bằng JS)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Khi có element mới được thêm vào
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            replaceCurrency(node);
          });
        } 
        // Khi text bên trong element bị thay đổi (VD: số tiền chạy từ 0 lên 16,01)
        else if (mutation.type === 'characterData') {
          if (mutation.target.nodeValue && mutation.target.nodeValue.includes('EUR')) {
            mutation.target.nodeValue = formatEUR(mutation.target.nodeValue);
          }
        }
      });
    });

    // Bắt đầu theo dõi toàn bộ body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  })();


(() => {
  if (window.__salepifyBundleVariantImageOverride) return;
  window.__salepifyBundleVariantImageOverride = true;

  const SELECTOR = '.salepify-product-bundle__variant-select';
  const CARD_SELECTOR = '.salepify-product-bundle__product-card';
  const productCache = new Map();

  function isDefaultTitleSelect(select) {
    if (!select || select.options.length !== 1) return false;

    const title = select.options[0].textContent
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    return title === 'default title';
  }

  function hideDefaultTitleSelect(select) {
    if (!isDefaultTitleSelect(select)) return;

    select.hidden = true;
    select.setAttribute('aria-hidden', 'true');
    select.style.setProperty('display', 'none', 'important');
  }

  function processVariantSelects(root = document) {
    if (root.matches?.(SELECTOR)) {
      hideDefaultTitleSelect(root);
    }

    root.querySelectorAll?.(SELECTOR).forEach(hideDefaultTitleSelect);
  }

  function getProductHandle(card) {
    const productLink = card.querySelector(
      '.salepify-product-bundle__product-title[href*="/products/"]'
    );

    if (!productLink) return null;

    try {
      const url = new URL(productLink.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);

      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function getProductData(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const normalizedRoot = shopifyRoot.endsWith('/')
      ? shopifyRoot
      : `${shopifyRoot}/`;

    const request = fetch(
      `${normalizedRoot}products/${encodeURIComponent(handle)}.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Unable to load product: ${response.status}`);
        }

        return response.json();
      })
      .catch((error) => {
        productCache.delete(handle);
        throw error;
      });

    productCache.set(handle, request);

    return request;
  }

  async function updateVariantImage(select) {
    const card = select.closest(CARD_SELECTOR);
    if (!card) return;

    const imageElement = card.querySelector(
      '.salepify-product-bundle__product-image'
    );

    const handle = getProductHandle(card);
    const selectedVariantId = String(select.value);

    if (!imageElement || !handle || !selectedVariantId) return;

    try {
      const product = await getProductData(handle);

      /*
       * Ngăn request cũ cập nhật sai ảnh nếu khách đổi variant
       * nhiều lần liên tiếp.
       */
      if (
        !select.isConnected ||
        String(select.value) !== selectedVariantId
      ) {
        return;
      }

      const selectedVariant = product.variants?.find(
        (variant) => String(variant.id) === selectedVariantId
      );

      const variantImage =
        selectedVariant?.featured_image?.src ||
        selectedVariant?.featured_media?.preview_image?.src;

      /*
       * Variant không có ảnh riêng:
       * giữ nguyên ảnh đang hiển thị.
       */
      if (!variantImage) return;

      imageElement.src = variantImage;

      /*
       * Tránh srcset cũ khiến browser tiếp tục hiển thị ảnh cũ.
       */
      if (imageElement.hasAttribute('srcset')) {
        imageElement.srcset = variantImage;
      }
    } catch (error) {
      /*
       * Không thay ảnh và không làm ảnh hưởng handler đổi giá
       * của Salepify nếu request product thất bại.
       */
    }
  }

  /*
   * Giữ nguyên onchange gốc của Salepify để app vẫn cập nhật
   * giá variant và tổng bundle.
   */
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.(SELECTOR);

    if (
      !select ||
      !select.closest('.salepify-product-bundle') ||
      isDefaultTitleSelect(select)
    ) {
      return;
    }

    updateVariantImage(select);
  });

  /*
   * Xử lý widget hiện có.
   */
  processVariantSelects(document);

  /*
   * Xử lý trường hợp Salepify render hoặc re-render widget sau đó.
   */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          processVariantSelects(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();